import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { axiosInstance } from '../../config';
import Loader from "../../../common/Loader"

const CommentForm = ({ post_id, type, setAllComments }) => {
    const [message, setMessage] = useState("");
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [loading, setLoading] = useState(false);
    const [posted, setPosted] = useState(false);
    const [errors, setErrors] = useState({});

    // const credentials = secureLocalStorage.getItem("credentials");

    const validateForm = () => {
        const errors = {};

        // Full Name Validation
        if (!fullName.trim()) {
            errors.fullName = "Full Name is required";
        }

        // Email Validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email.trim()) {
            errors.email = "Email is required";
        } else if (!emailRegex.test(email)) {
            errors.email = "Please enter a valid email address";
        }

        // Subject Validation
        if (!subject.trim()) {
            errors.subject = "Subject is required";
        }

        // Message Validation
        if (!message.trim()) {
            errors.message = "Message is required";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0; // return true if no errors
    };

    const handlePostComment = async (event) => {
        event.preventDefault();

        // Validate the form before submitting
        if (!validateForm()) {
            return; // Don't proceed if validation fails
        }

        // Simulating the form submission with an API request
        try {
            // if (credentials) {
            setLoading(true);
            const formData = new FormData();
            formData.append("description", message);
            formData.append("name", fullName);
            formData.append("email", email);
            formData.append("subject", subject);
            formData.append("post_id",post_id);
            
            const response = await axiosInstance.post(`add-comment`, formData); // Use this mock API request for testing

            if (response.data.success) {
                setLoading(false);
                toast.success("Comment Submitted");
                setMessage("");
                setFullName("");
                setEmail("");
                setSubject("");
                setPosted(true);
                setTimeout(() => setPosted(false), 10000);
            }
            else {
                setLoading(false);
                toast.error("Please try Again.");
            }

        } catch (error) {
            setLoading(false);
            toast.error("An error occurred while posting your comment.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {loading && <Loader/>}
            <div>
                {posted && (
                    <div className="alert alert-success border-0 d-flex justify-content-between align-items-center py-2 fw-500">
                        <div>Comment Posted Successfully</div>
                        <div onClick={() => setPosted(false)} style={{ cursor: 'pointer' }}>
                            <i className="bi bi-x fs-3"></i>
                        </div>
                    </div>
                )}
            </div>
            <form onSubmit={handlePostComment} className="comment-form">
                <div className="row mx-0">
                    <div className="col-md-6 mb-4">
                        <div>
                            <div className="position-relative">
                                <input
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    placeholder="Enter Full Name"
                                    className="comment-field"
                                    required
                                />
                                {errors.fullName && <div className="error-text">{errors.fullName}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div>
                            <div className="position-relative">
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email Address"
                                    className="comment-field"
                                    required
                                />
                                {errors.email && <div className="error-text">{errors.email}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div>
                            <div className="position-relative">
                                <input
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    placeholder="Subject"
                                    className="comment-field"
                                    required
                                />
                                {errors.subject && <div className="error-text">{errors.subject}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mb-4">
                        <div>
                            <div className="position-relative">
                                <textarea
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Write your comment here"
                                    className="comment-field"
                                    required
                                ></textarea>
                                {errors.message && <div className="error-text">{errors.message}</div>}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="my-4 ps-3">
                    <button type="submit" className="comment-btn" disabled={loading}>
                        <i className={`bi bi-${loading ? 'opencollective rotate-icon' : 'send'} me-3 text-yellow`}></i>
                        Post Comment
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CommentForm;
